import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=5f0b3f56&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=5f0b3f56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b3f56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0b3f56')) {
      api.createRecord('5f0b3f56', component.options)
    } else {
      api.reload('5f0b3f56', component.options)
    }
    module.hot.accept("./ComingSoon.vue?vue&type=template&id=5f0b3f56&scoped=true", function () {
      api.rerender('5f0b3f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ComingSoon.vue"
export default component.exports